import { render, staticRenderFns } from "./Recipients.vue?vue&type=template&id=5c1934ca&scoped=true&"
import script from "./Recipients.vue?vue&type=script&lang=ts&"
export * from "./Recipients.vue?vue&type=script&lang=ts&"
import style0 from "./Recipients.vue?vue&type=style&index=0&id=5c1934ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1934ca",
  null
  
)

export default component.exports